module.exports = __webpack_public_path__ + "assets/images/project/constituencies/hougang-smc.jpg?v=5092a16a";